import { render, staticRenderFns } from "./SurrenderOfShares.vue?vue&type=template&id=6703042f&scoped=true&"
import script from "./SurrenderOfShares.vue?vue&type=script&lang=js&"
export * from "./SurrenderOfShares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6703042f",
  null
  
)

export default component.exports